import '@amo/core/assets/scss/index.scss';
import { Maintenance } from '@amo/core/components/containers';
import { APP_ENV } from '@amo/core/constants';
import { sentryInit } from '@amo/core/utils/vitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from 'react-dom/client';
import AppProvider from './AppProvider';

window.dataLayer = window.dataLayer || [];
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}
window.dataLayer.push({
    environnement: APP_ENV,
});

const isMaintenance = window.location.pathname === '/maintenance';

const container = document.getElementById('root');
const root = createRoot(container);

if (isMaintenance) {
    root.render(<Maintenance />);
} else if (APP_ENV) {
    root.render(<AppProvider />);
} else {
    root.render(<h1>.env requis à la racine du projet, un npm start est nécessaire.</h1>);
}

sentryInit();
